import React from 'react';
import { FaChartPie } from 'react-icons/fa';
import { FaShield, FaTriangleExclamation } from 'react-icons/fa6';
import { Doughnut } from 'react-chartjs-2'; // Import the Chart wrapper
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import AdapIdStatsCard from '../AdapidStatsCard/AdapidStatsCard'; // Ensure this matches the file location of your new StatsCard
import './MfaOverviewStats.css';

const MfaOverviewStats = ({ stats, loading = false }) => {
  // console.log("MFAstats", stats);

  // 1. Extract dynamic metrics safely from your data stream
  const legitimate = stats?.data?.legitimate_count || 0;
  const insufficient = stats?.data?.insufficient_count || 0;
  const suspicious = stats?.data?.suspicious_count || 0;
  
  const total = stats?.data?.total || (legitimate + insufficient + suspicious);

  // 2. Setup your Chart.js data configuration object
  const doughnutData = {
    labels: ['Legitimate', 'Insufficient', 'Suspicious'],
    datasets: [
      {
        data: [legitimate, insufficient, suspicious],
        backgroundColor: [
          '#10b981', // Emerald
          '#f97316', // Orange
          '#ef4444'  // Red
        ],
        borderWidth: 0, // Removes white borders between segments to keep it clean
        cutout: '65%',  // Controls the thickness of the doughnut hole (inner radius match)
      },
    ],
  };

  // 3. Prevent automatic aspect ratio scaling issues inside small container slots
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: { enabled: true },
      legend: { display: false } // We don't need a text legend inside the tiny card slot
    }
  };

  const themes = {
    success: { bg: "rgb(236, 253, 245)", text: "rgb(16, 185, 129)" },
    warning: { bg: "rgb(255, 247, 237)", text: "rgb(249, 115, 22)" },
    danger: { bg: "rgb(254, 242, 242)", text: "rgb(239, 68, 68)" }
  };

  const primaryStats = [
    {
      title: 'Legitimacy Rate',
      value: `${(stats?.data?.legitimate_rate)}%`|| '0%',
      
      // Pass the Chart.js canvas component explicitly bounded within custom dimensions
      icon: (
        <div style={{ width: '75px', height: '65px', position: 'relative' }}>
          <Doughnut data={doughnutData} options={chartOptions} />
        </div>
      ),
      themeColors: null, // Keeps standard layout node styling clear of background padding wrappers
      subLabel: `${total.toLocaleString()} total`,
    },
    {
      title: 'Legitimate Attempts',
      value: legitimate,
      icon: <FaShield/>,
      themeColors: themes.success,
      subLabel: null
    },
    {
      title: 'Profile Not Created',
      value: insufficient,
      icon: <FaShield/>,
      themeColors: themes.warning,
      subLabel: null
    },
    {
      title: 'Suspicious Attempts',
      value: suspicious,
      icon: <FaTriangleExclamation />,
      themeColors: themes.danger,
      subLabel: null
    }
  ];

  return (
    <div className="identity-stats">
      <div className="stats-grid-primary">
        {primaryStats.map((stat, index) => (
          <AdapIdStatsCard
            key={index}
            title={stat.title}
            value={stat.value}
            leftElement={stat.icon}
            themeColors={stat.themeColors}
            subLabel={stat.subLabel}
            loading={loading}
          />
        ))}
      </div>
    </div>
  );
};

export default MfaOverviewStats;